<div id="anlagenWrapper" class="clr-row nxm h-100" data-test-id="anlagen-header">
  <div
    #datagridwrapper
    class="d-f col gap-5 h-100"
    [ngStyle]="{
      width:
        !showdetailview || hidedetailview ? '100%'
        : split50 ? '50%'
        : '66.66%',
    }">

    
    @if(this.authService.getRight('view', 'AllowVANL')) {
      <div class="clr-row">
        <div class="clr-col" style="align-items: center; column-gap: 0.2rem; display: inline-flex">
          @if (token()?.rights?.progVersion == '45' && authService.token.rights.status > 2) {
            <clr-dropdown
              class="UserManagement"
              id="PropertiesDropdown"
              style="display: inline-flex; align-items: center">
              @let canWerksabnahmeNew = !isAuthLoading && canCreateWerksabnahme() && !isRep;
              @let stItemsAll = sotyp | keyvalue;
              @let allowedStUser = !isOktaUser() || isInternalOrAdminOkta();
              @let hasCopyNew = !isRep && (typid | objtype: 'point') && allowedStUser;
              @let hasStMenuNew = sotyp && allowedStUser && (stItemsAll?.length > 0 || hasCopyNew);
              @let hasNewMenuItems = isAuthLoading || canWerksabnahmeNew || hasStMenuNew;

              <button
                class="btn btn-primary btn-sm neu-button"
                clrDropdownTrigger
                data-test-id="anlagen-neu-dropdown"
                [disabled]="!hasNewMenuItems">
                <span class="btn-icon-left"><cds-icon shape="plus" /></span>
                <span class="btn-label">{{ 'Neu' | mrTranslate }}</span>
                <span class="btn-icon-right"><cds-icon shape="angle" direction="down" /></span>
              </button>
              @if (hasNewMenuItems) {
                <clr-dropdown-menu *clrIfOpen>
                  <!-- Show loading indicator during auth check -->
                  @if (isAuthLoading) {
                    <div clrDropdownItem class="disabled">
                      <cds-icon shape="refresh" class="is-spinning" />
                      {{ 'Lade Berechtigungen...' | mrTranslate }}
                    </div>
                  }

                  <!-- Show Werksabnahme only when permissions are loaded and available -->
                  @if (!isAuthLoading && canCreateWerksabnahme() && !isRep) {
                    <a (click)="openFATObjectcreation()" clrDropdownItem data-test-id="anlagen-werksabnahme-create">
                      {{ 'Werksabnahme - neues Objekt erstellen' | mrTranslate }}
                    </a>
                  }

                  @if (sotyp && !isOktaUser()) {
                    @let stItems = sotyp | keyvalue;
                    @if (stItems?.length > 0 || hasCopyNew) {
                      <clr-dropdown>
                        <button clrDropdownTrigger>{{ 'Stammdaten erstellen' | mrTranslate }}</button>
                        <clr-dropdown-menu *clrIfOpen>
                          @for (typ of stItems; track typ.key) {
                            <a (click)="openNeuStamm(sotyp[typ.key])" clrDropdownItem>
                              <cds-icon
                                style="margin-left: -10px; color: #000"
                                class="grid-icon"
                                [shape]="'objekttyp' + typ.value.symbol"
                                size="22" />
                              {{ typ.value.bezeichnung }}
                            </a>
                          }

                          @if (!isRep && !isOktaUser()) {
                            <div class="dropdown-divider" role="separator"></div>
                            <a (click)="isCopyStammOpen.set(true)" clrDropdownItem [class.disabled]="!selectedRow()">
                              {{ 'Stammdaten kopieren' | mrTranslate }}
                            </a>
                          }
                        </clr-dropdown-menu>
                      </clr-dropdown>
                    }
                  }
                </clr-dropdown-menu>
              }
            </clr-dropdown>
          }

          @if (table().rows?.length; as rowsLength) {
            @if (rowsLength != filteredRows()?.length) {
              <button
                class="btn btn-primary btn-sm"
                style="min-width: 52px"
                (click)="filterStore.deleteAllFilters()"
                data-test-id="anlagen-filter-clear">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="filter-off" />
                  <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                    {{ 'Alle Filter zurücksetzen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
              <button
                class="btn btn-primary btn-sm"
                style="min-width: 52px; margin-left: -12px"
                (click)="showObjektFilters()"
                data-test-id="anlagen-object-filter">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="filter" />
                  <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'lg'">
                    {{ 'Filter nach Objekt-Eigenschaften' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            } @else {
              <button
                class="btn btn-primary btn-sm"
                style="min-width: 52px"
                (click)="showObjektFilters()"
                data-test-id="anlagen-object-filter">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="filter" />
                  <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'lg'">
                    {{ 'Filter nach Objekt-Eigenschaften' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
          }

          <button
            class="btn btn-primary btn-sm"
            style="min-width: 52px"
            (click)="switchViews()"
            data-test-id="anlagen-object-filter">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger [shape]="!isTreeView ? 'tree-view' : 'table'" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'lg'">
                {{ 'Wechsle Ansicht' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>

          @if (KRPUV.length > 1) {
            <label>{{ 'Prüfungstyp' | mrTranslate }}:</label>
            <clr-select-container style="margin-top: 0px">
              <select
                clrSelect
                id="Ptyp"
                [ngModel]="pruefungsTyp.KPRUVID()"
                (ngModelChange)="changeKPRUV($event)"
                [ngModelOptions]="{ standalone: true }">
                @for (name of KRPUV; track name) {
                  <option [ngValue]="+name.ID">{{ name.Bezeichnung }}</option>
                }
              </select>
            </clr-select-container>
          }
        </div>

        <div class="clr-col" style="display: flex; justify-content: flex-end">
          @if (!isOktaUser() && (token()?.rights?.status >= 2 || token()?.rights?.dev == true)) {
            @if (!isRep) {
              <button
                class="btn btn-outline btn-sm"
                style="min-width: 42px"
                (click)="isUserReplikatModalOpen.set(true)"
                [disabled]="!allowRepErstellen()">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="rep_user" size="20" class="cursor-pointer" />
                  <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                    {{ 'Replikat für Inspektion erstellen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            } @else {
              <button class="btn btn-outline btn-sm" style="min-width: 42px" (click)="stopReplicate()">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="rep_upload" size="20" class="cursor-pointer" />
                  <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                    {{ 'Replikat zurückspielen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
            @if (!isOktaUser() || isInternalOrAdminOkta()) {
              <button
                class="btn btn-outline btn-sm"
                style="min-width: 42px"
                (click)="getSammelausdruck()"
                data-test-id="anlagen-sammelauswertung">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="view-list" size="20" class="cursor-pointer" />
                  <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                    {{ 'Sammelauswertung' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }

            @if (!isRep && !isExternalOnly()) {
              <button
                class="btn btn-outline btn-sm"
                style="min-width: 42px"
                (click)="showSammelExport()"
                data-test-id="anlagen-sammelexport">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="export" size="20" class="cursor-pointer" />
                  <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                    {{ 'Sammelexport' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }

            @if (!isExternalOnly()) {
              <button
                class="btn btn-outline btn-sm"
                style="min-width: 42px"
                (click)="getExcelList()"
                data-test-id="anlagen-excel-export">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="excel" size="20" class="cursor-pointer" />
                  <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                    {{ 'Excel Export' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            }
          }
          <button
            class="btn btn-outline btn-sm"
            style="min-width: 42px"
            (click)="getQRCode()"
            data-test-id="anlagen-qr-scan">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="qr-code" size="20" class="cursor-pointer" />
              <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                {{ 'QR-Code scannen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>

          <button
            class="btn btn-outline btn-sm"
            style="min-width: 42px"
            (click)="reloadAnlagen()"
            data-test-id="anlagen-reload">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="refresh" size="20" class="cursor-pointer" />
              <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                {{ 'neu laden' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </div>
      </div>
    }

    @if (isAnlagenLoading()) {
      <clr-spinner class="centred" />
    } @else {
      @if (isTreeView) {
        <clr-tree [clrLazy]="true" id="anlagenTree" class="datagrid datagrid-body">
          <clr-tree-node
            *clrRecursiveFor="let item of listTreeNote; getChildren: getChildren"
            [(clrExpanded)]="item.expanded">
            <a class="clr-treenode-link" (click)="treeClick(item)">
              <cds-icon [shape]="item.typ" size="18" />
              {{ item.name }}
            </a>
          </clr-tree-node>
        </clr-tree>
      } @else if (table().columns?.length) {
        <clr-datagrid
          class="datagrid-compact fill-space"
          [attr.data-test-id]="'datagrid-anlagen'"
          [clrDgSelectionType]="'single'"
          [clrDgSelected]="[selectedRow()]"
          (clrDgSelectedChange)="selectedRow.set($event[0])"
          [clrDgItemsIdentityFn]="row => row?.OSTAMMID">
          @for (column of table().columns; track column.id) {
            <clr-dg-column
              #columns
              [clrDgField]="column.id"
              [attr.id]="'datagrid-anlagen-col-' + (column.id | get: normalizedId)"
              [attr.data-test-id]="'datagrid-anlagen-col-' + column.id">
              <clr-dg-filter [attr.data-test-id]="'datagrid-anlagen-col-filter-' + column.id">
                <app-column-filter
                  [column]="column"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>

              <ng-template
                [clrDgHideableColumn]="hideableState(column.id)"
                (clrDgHiddenChange)="columnHiddenChange()">
                {{
                  column.id == 'KAV' ?
                    table().rows[0]?.KAV?.toString().includes('%') ?
                      'SAX'
                    : 'KAV'
                  : (column.id | titlecase | mrUnitText)
                }}
              </ng-template>
            </clr-dg-column>
          }

          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="filteredRows()"
            [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID"
            [clrVirtualRowsItemSize]="32"
            [clrVirtualRowsMaxBufferPx]="3000">
            <clr-dg-row
              [clrDgItem]="row"
              [attr.data-test-id]="'anlagen-table-row'"
              [attr.data-row-id]="row.OSTAMMID"
              [attr.data-object-name]="row.bezeichnung || row.Bezeichnung">
              <clr-dg-action-overflow>
                @if (hasMap && token()?.rights?.status > 2) {
                  <button
                    class="action-item"
                    (click)="openObjectInGISMap(row.OSTAMMID)"
                    data-test-id="anlagen-action-gis-map"
                    [disabled]="isFatUiLimited()"
                    [title]="isFatUiLimited() ? ('FAT-Kontext' | mrTranslate) : null">
                    <cds-icon size="18" shape="map-marker" />
                    &nbsp;{{ 'in GIS Map öffnen' | mrTranslate }}
                  </button>
                }

                @if (!isRep && token()?.rights?.status > 2) {
                  <button
                    class="action-item"
                    (click)="fileUploader.click()"
                    [disabled]="isOktaUser() || isExternalOnly()"
                    [title]="isOktaUser() && isExternalOnly() ? ('Nur interne Benutzer' | mrTranslate) : null">
                    <cds-icon size="18" shape="import" />
                    &nbsp;{{ 'SRE Messdaten importieren' | mrTranslate }}
                  </button>
                  <input
                    type="file"
                    #fileUploader
                    id="fileUploader"
                    name="fileUploader"
                    accept=".gsiar"
                    hidden
                    (change)="onFileChange($event, row)" />

                  <button
                    class="action-item"
                    (click)="fileIFCUploader.click()"
                    [disabled]="isOktaUser() || isExternalOnly()"
                    [title]="isOktaUser() && isExternalOnly() ? ('Nur interne Benutzer' | mrTranslate) : null">
                    <cds-icon size="18" shape="import" />
                    &nbsp;{{ 'IFC-Daten anzeigen' | mrTranslate }}
                  </button>
                  <input
                    type="file"
                    #fileIFCUploader
                    id="fileIFCUploader"
                    name="fileIFCUploader"
                    accept=".ifc, .wexBIM"
                    hidden
                    (change)="onIFCFileChange($event, row)" />
                }
                @if (with_EBL_ALV()) {
                  @if (token().alv === 'True') {
                    <button
                      class="action-item"
                      (click)="set_ALV_Checked(row.LPID, 1)"
                      [disabled]="row['ALV'] || !row['LPID'] || row['LPID'] == 0">
                      <cds-icon size="22" shape="check-circle" />
                      {{ 'durch ALV bestätigen' | mrTranslate }}
                    </button>
                  }
                  @if (token().ebl === 'True') {
                    <button
                      class="action-item"
                      (click)="set_ALV_Checked(row.LPID, 2)"
                      [disabled]="row['EBL'] || !row['LPID'] || row['LPID'] == 0">
                      <cds-icon size="22" shape="check-circle" />
                      {{ 'durch EBL bestätigen' | mrTranslate }}
                    </button>
                  }
                }

                <!-- Show Werksabnahme actions when the user is eligible; rely on reactive permission evaluation -->
                @if (isFatUiLimited() && isInternalOrAdminOkta()) {
                  <div class="UserManagement">
                    @if (row | get: canPerformWerksabnahme) {
                      <button
                        class="action-item"
                        (click)="openFATPruefungcreation(row.OSTAMMID, row.LPID)"
                        data-test-id="anlagen-action-werksabnahme-durchfuehren">
                        <cds-icon size="18" shape="factory" />
                        &nbsp;{{ 'Werksabnahme durchführen' | mrTranslate }}
                      </button>
                    }
                    @if (row | get: canEditWerksabnahme) {
                      <button
                        class="action-item"
                        (click)="openFATPruefungcreationEdit(row.OSTAMMID, row.LPID)"
                        data-test-id="anlagen-action-werksabnahme-bearbeiten">
                        <cds-icon size="18" shape="note" />
                        &nbsp;{{ 'Werksabnahme bearbeiten' | mrTranslate }}
                      </button>
                    }
                    @if (row | get: canDeleteWerksabnahme) {
                      <button
                        class="action-item"
                        (click)="deleteWerksabnahme(row.OSTAMMID, row.LPID)"
                        data-test-id="anlagen-action-werksabnahme-loeschen">
                        <cds-icon size="18" shape="trash" />
                        &nbsp;{{ 'Werksabnahme löschen' | mrTranslate }}
                      </button>
                    }
                  </div>
                }

                @if (row['SI'] == 1) {
                  <button class="action-item" (click)="openSonderinspektion(row)">
                    <cds-icon size="18" shape="warning-standard" />
                    &nbsp;{{ 'Sonderinspektion öffnen' | mrTranslate }}
                  </button>
                }
              </clr-dg-action-overflow>

              @for (cell of table().columns; track cell.id) {
                <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
              }
            </clr-dg-row>
          </ng-template>

          <clr-dg-footer #dgFooter>
            <div class="footerbox">
              <div class="footerbox-actions">
                <button class="minibutton" [title]="'Spaltenfilter löschen' | mrTranslate" (click)="removeColFilter()">
                  <cds-icon shape="filter-off" />
                </button>
                <app-column-manager-popup
                  [columns]="table().columns"
                  [hiddenIds]="hides"
                  (configChange)="onColumnConfigChange($event)"></app-column-manager-popup>
              </div>
              <div class="dbNameTable">{{ formatDBName }}</div>
              <div class="dbLengthTable">{{ 'Gesamtlänge:' | mrTranslate }} {{ anlagenLenght() }} m</div>
              <div>{{ filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</div>
            </div>
          </clr-dg-footer>
        </clr-datagrid>
      }
    }
  </div>
  @if (showdetailview && ostammid()) {
    <div #dvwrapper id="wrapperdetailview" [ngClass]="{ sidenavenlarged, split50, hidedetailview }">
      <app-detailview
        [rechte]="rechte"
        [ostammid]="ostammid()"
        [progressbarenlarged]="progressbarenlarged"
        [expanded]="sidenavenlarged"
        [hidden]="hidedetailview"
        [split50]="split50"
        (enlarge)="enlargeSidenav($event)"
        (enlargePB)="enlargeProgressbar(true)"
        (progressData)="showProgressData($event)"
        (indexScrub)="handleScrub($event)"
        (reload)="reloadAnlagen($event)"
        #detailView></app-detailview>
    </div>
  }
</div>

@if (showprogressbar) {
  <div id="progresstrigger" [class.bottom]="!progressbarenlarged">
    <div class="wrap" (click)="enlargeProgressbar()">
      <!-- |onKeyPress|onKeyDown|onKeyUp -->
      <cds-icon
        shape="angle"
        [direction]="progressbarenlarged ? 'down' : 'up'"
        class="expandProgressbarButton cursor-pointer" />
    </div>
  </div>
  @if (progressbarenlarged) {
    <footer id="wrapperprogressbars" class="clr-row nxm clr-align-items-center">
      <app-progressbar
        [dataIn]="progressbars"
        [indexScrub]="indexScrub"
        (enlargeProgressbar)="enlargeProgressbar(true)"
        style="display: inline-block; width: calc(100% - 35px)" />
    </footer>
  }
}

@if (isALVModalVisible) {
  <clr-modal [(clrModalOpen)]="isALVModalVisible" [clrModalClosable]="true">
    <h3 class="modal-title">{{ alvHeader }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal">
        <clr-radio-container class="margin-0-t">
          <label style="display: table">{{ 'Zustand' | mrTranslate }}</label>
          <clr-radio-wrapper>
            <input type="radio" clrRadio clrRadio [(ngModel)]="alvstatus" name="radio-alv" [value]="3" />
            <label>{{ 'Gut' | mrTranslate }}</label>
          </clr-radio-wrapper>
          <clr-radio-wrapper>
            <input type="radio" clrRadio [(ngModel)]="alvstatus" name="radio-alv" [value]="2" />
            <label>{{ 'Medium' | mrTranslate }}</label>
          </clr-radio-wrapper>
          <clr-radio-wrapper>
            <input type="radio" clrRadio [(ngModel)]="alvstatus" name="radio-alv" [value]="1" />
            <label>{{ 'Schlecht' | mrTranslate }}</label>
          </clr-radio-wrapper>
          <clr-radio-wrapper>
            <input type="radio" clrRadio [(ngModel)]="alvstatus" name="radio-alv" [value]="0" checked="true" />
            <label>{{ 'Undefiniert' | mrTranslate }}</label>
          </clr-radio-wrapper>
        </clr-radio-container>

        <clr-textarea-container>
          <label>{{ 'Bemerkung' | mrTranslate }}</label>
          <textarea clrTextarea name="bemerkung" #alvbem></textarea>
        </clr-textarea-container>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="updateALVStatus()">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="isALVModalVisible = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}
@if (isCopyStammOpen()) {
  <clr-modal
    [clrModalOpen]="isCopyStammOpen()"
    (clrModalOpenChange)="isCopyStammOpen.set($event)"
    [clrModalSize]="'md'"
    [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Stammdaten kopieren' | mrTranslate }}</h3>
    <div class="modal-body clr-row nxm">
      <form
        id="copy-stamm-form"
        clrForm
        (ngSubmit)="f.valid && copyStamm()"
        #f="ngForm"
        clrLayout="horizontal"
        [clrLabelSize]="4"
        class="width100 clr-col-12">
        <clr-input-container>
          <label>{{ 'Neue Bezeichnung' | mrTranslate }}</label>
          <input
            type="text"
            clrInput
            [(ngModel)]="copyStammBez"
            name="bezeichnung"
            required
            [autofocus]="isCopyStammOpen()" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-input-container>
      </form>
    </div>
    <div class="modal-footer">
      <button type="submit" form="copy-stamm-form" class="btn btn-primary">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="isCopyStammOpen.set(false)">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}
@if (qrScanModal) {
  <clr-modal [(clrModalOpen)]="qrScanModal" [clrModalSize]="'md'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'QR-Code Scannen' | mrTranslate }}</h3>
    <div class="modal-body">
      <video id="video"></video>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn" (click)="qrScanModal = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}
@if (showSREModal) {
  <clr-modal [(clrModalOpen)]="showSREModal" [clrModalSize]="'xl'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Soniq Rail Explorer Messdaten importieren' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal" style="margin-top: -5px">
        <table class="table">
          <thead>
            <tr>
              <th>Inspection type</th>
              <th>Channel no.</th>
              <th>Position [mm]</th>
              <th>Width [mm]</th>
              <th>Height [mm]</th>
              <th>Amplitude max.</th>
              <th>UIC classification</th>
              <th>Class</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            @for (item of sreList; track item) {
              <tr>
                <td>analysis measurement</td>
                <td>{{ item.ChannelNumber }}</td>
                <td>X: {{ item.LeftX }}, Y: {{ item.LeftY }}</td>
                <td>{{ item.Width }}</td>
                <td>{{ item.Height }}</td>
                <td>{{ item.AmplitudeMaximum }}</td>
                <td>{{ item.ClassificationId }}</td>
                <td>{{ item.Klasse }}</td>
                <td>{{ item.Schienenfehler }}</td>
              </tr>
            }
          </tbody>
        </table>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="doimportRSE()">{{ 'OK' | mrTranslate }}</button>
      <button type="button" class="btn" (click)="showSREModal = false">{{ 'Abbrechen' | mrTranslate }}</button>
    </div>
  </clr-modal>
}
@if (showFilerObjectModal) {
  <clr-modal [(clrModalOpen)]="showFilerObjectModal" [clrModalSize]="'lg'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Datenfilter nach Eigenschaft' | mrTranslate }}</h3>
    <div class="modal-body">
      <div class="clr-form-horizontal">
        <div class="clr-row">
          <div class="clr-col-2">
            <div>{{ 'Objekttyp' | mrTranslate }}</div>
          </div>
          <div class="clr-col">
            @if (sotyp; as objekte) {
              <clr-select-container>
                <label style="width: auto; padding: 0 2px">
                  @if (objekte[otypid]?.symbol; as symbol) {
                    <cds-icon style="color: #000" class="grid-icon" [shape]="'objekttyp' + symbol" size="22" />
                  }
                </label>
                <select
                  clrSelect
                  name="objekt"
                  class="cur-color"
                  [(ngModel)]="otypid"
                  (ngModelChange)="filterObjektSelected()"
                  [ngModelOptions]="{ standalone: true }">
                  <option [ngValue]="0">-</option>
                  @for (typ of objekte | keyvalue; track typ.key) {
                    <option [ngValue]="+typ.key">{{ typ.value.bezeichnung }}</option>
                  }
                </select>
              </clr-select-container>
            }
          </div>
        </div>
        <div class="clr-row" style="margin-top: 10px">
          <div class="clr-col-2">
            <div>{{ 'Stammdaten' | mrTranslate }}</div>
          </div>
          <div class="clr-col">
            @if (selKSPEZV?.length) {
              <clr-select-container>
                <select
                  clrSelect
                  name="objekt"
                  class="cur-color"
                  style="min-width: 250px"
                  ngModel
                  (ngModelChange)="filterStammSelected($event)"
                  [ngModelOptions]="{ standalone: true }">
                  @for (typ of selKSPEZV; track typ.SFELDNA) {
                    <option [value]="typ.SFELDNA">{{ typ.KFELDNA }}</option>
                  }
                </select>
              </clr-select-container>
            }
          </div>
        </div>

        <div class="limit-height">
          @if (stammdaten?.length) {
            <clr-datagrid
              #dgStammdaten
              style="padding-top: 0px"
              class="datagrid-compact w-100-p"
              [clrDgRowSelection]="true"
              [clrDgSelectionType]="'multi'"
              [(clrDgSelected)]="filterselected">
              <clr-dg-column [clrDgField]="'Bezeichnung'">
                {{ 'Bezeichnung' | mrTranslate }}
              </clr-dg-column>
              <ng-template
                clrVirtualScroll
                let-row
                [clrVirtualRowsOf]="stammdaten"
                [clrVirtualRowsTrackBy]="(_, row) => row?.Bezeichnung">
                <clr-dg-row [clrDgItem]="row.Bezeichnung">
                  <clr-dg-cell class="name-cell">
                    {{ row.Bezeichnung ?? '-' | tablePrettyPrint }}
                  </clr-dg-cell>
                </clr-dg-row>
              </ng-template>
              <clr-dg-footer>{{ stammdaten.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>
          } @else {
            <div style="height: 400px"></div>
          }
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        (click)="setObjektFilters()"
        [disabled]="filterselected.length == 0">
        {{ 'Anwenden' | mrTranslate }}
      </button>
      <button type="button" class="btn" (click)="showFilerObjectModal = false">{{ 'Beenden' | mrTranslate }}</button>
    </div>
  </clr-modal>
}
@if (showModalSammelexport) {
  <clr-modal [(clrModalOpen)]="showModalSammelexport" [clrModalSize]="'lg'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Sammelexport' | mrTranslate }}</h3>
    <div class="modal-body">
      <div class="clr-form-horizontal">
        <div class="clr-row">
          <div class="clr-col-3">
            <div>{{ 'Objekttyp' | mrTranslate }}</div>
          </div>
          <div class="clr-col">
            '
            @if (sotyp; as objekte) {
              <clr-select-container style="margin-top: -25px">
                <label style="width: auto; padding: 0 2px">
                  @if (objekte[otypid]?.symbol; as symbol) {
                    <cds-icon style="color: #000" class="grid-icon" [shape]="'objekttyp' + symbol" size="22" />
                  }
                </label>
                <select
                  clrSelect
                  name="objekt"
                  class="cur-color"
                  [(ngModel)]="otypid"
                  (ngModelChange)="filterObjektSelected()"
                  [ngModelOptions]="{ standalone: true }">
                  <option [ngValue]="0">-</option>
                  @for (typ of objekte | keyvalue; track typ.key) {
                    <option [ngValue]="+typ.key">{{ typ.value.bezeichnung }}</option>
                  }
                </select>
              </clr-select-container>
            }
          </div>
        </div>
        <br />
        <div class="clr-row">
          <div class="clr-col-3">
            <div>{{ 'Zeitraum' | mrTranslate }}</div>
          </div>
          <div class="clr-col-3">
            <clr-date-container>
              <input
                type="date"
                clrDate
                [ngModel]="datumvon | localeDate"
                (ngModelChange)="handleChangeDate(0, $event)"
                [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                [max]="datummax" />
            </clr-date-container>
          </div>
          <div class="clr-col-3">
            <clr-date-container>
              <input
                type="date"
                clrDate
                [ngModel]="datumbis | localeDate"
                (ngModelChange)="handleChangeDate(1, $event)"
                [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                [max]="datummax" />
            </clr-date-container>
          </div>
        </div>
        <br />

        <div class="clr-row">
          <div class="clr-col-3">
            <div>{{ 'Filter' | mrTranslate }}</div>
          </div>
          <div class="clr-col-3">
            <clr-radio-wrapper>
              <input
                type="radio"
                clrRadio
                value="option1"
                name="options1"
                [checked]="_bereich === 0"
                (change)="handleChangeBereich(0, $event)" />
              <label>{{ 'alle Bereiche' | mrTranslate }}</label>
            </clr-radio-wrapper>
          </div>
          <div class="clr-col-3">
            <clr-radio-wrapper>
              <input
                type="radio"
                clrRadio
                value="option2"
                name="options1"
                [checked]="_bereich === 1"
                (change)="handleChangeBereich(1, $event)" />
              <label>{{ 'bestimmter Bereich' | mrTranslate }}</label>
            </clr-radio-wrapper>
          </div>
        </div>
        <br />

        @if (_bereich === 1) {
          <div class="clr-row">
            <div class="clr-col-3"></div>
            <div class="clr-col-3">
              <clr-select-container>
                <label>{{ 'Bezirk' | mrTranslate }}</label>
                <select
                  clrSelect
                  name="bez"
                  class="cur-color"
                  style="min-width: 350px"
                  (ngModelChange)="sammelSelectedbez($event)"
                  [(ngModel)]="__bez"
                  [ngModelOptions]="{ standalone: true }">
                  @for (typ of dataBez | keyvalue; track typ.key) {
                    <option [ngValue]="+typ.key">
                      {{ typ.value }}
                    </option>
                  }
                </select>
              </clr-select-container>
            </div>
          </div>
          <br />
          <div class="clr-row">
            <div class="clr-col-3"></div>
            <div class="clr-col-3">
              <clr-select-container>
                <label>{{ 'Stellwerk' | mrTranslate }}</label>
                <select
                  clrSelect
                  name="stw"
                  class="cur-color"
                  style="min-width: 350px"
                  (ngModelChange)="sammelSelectedstw($event)"
                  [(ngModel)]="__stw"
                  [ngModelOptions]="{ standalone: true }">
                  @for (typ of dataSTW | keyvalue; track typ.key) {
                    <option [ngValue]="+typ.key">
                      {{ typ.value }}
                    </option>
                  }
                </select>
              </clr-select-container>
            </div>
          </div>
          <br />

          <div class="clr-row">
            <div class="clr-col-3"></div>
            <div class="clr-col-3">
              <clr-select-container>
                <label>{{ 'MessReg Bezirk' | mrTranslate }}</label>
                <select
                  clrSelect
                  name="mbez"
                  class="cur-color"
                  style="min-width: 350px"
                  (ngModelChange)="sammelSelectedmbez($event)"
                  [(ngModel)]="__mbez"
                  [ngModelOptions]="{ standalone: true }">
                  @for (typ of dataMBez | keyvalue; track typ.key) {
                    <option [ngValue]="+typ.key">
                      {{ typ.value }}
                    </option>
                  }
                </select>
              </clr-select-container>
            </div>
          </div>
          <br />
          <div class="clr-row">
            <div class="clr-col-3"></div>
            <div class="clr-col-3">
              <clr-input-container>
                <label>{{ 'Bezeichnung' | mrTranslate }}</label>
                <input
                  clrInput
                  name="name"
                  style="width: 350px"
                  (keyup.enter)="sammelSelectedName($event.target.value)"
                  [(ngModel)]="__name"
                  [ngModelOptions]="{ standalone: true }" />
              </clr-input-container>
            </div>
          </div>
          <br />
        }
        <br />
        <br />
      </div>
      @if (taskRun) {
        <span style="position: absolute; left: 25px; margin-top: 10px">{{ info }}</span>
        <clr-progress-bar [clrValue]="pcnt" clrLabeled></clr-progress-bar>
      }
    </div>
    <div class="modal-footer">
      <span style="position: absolute; left: 25px; margin-top: 10px">
        {{ anzSammel }} {{ 'Prüfungen' | mrTranslate }}
      </span>

      @if (dosammel) {
        <div>
          <span class="spinner spinner-md">Loading...</span>
        </div>
      }

      <div class="btn-group btn-outline-primary btn-icon">
        <button class="btn" (click)="SammelTagesbericht()" [disabled]="anzSammel == 0 && token()?.rights?.dev == true">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="details" size="'lg'" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'lg'">
              {{ 'erzeuge Inhalt für Tagesbericht' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>

        <button class="btn" (click)="SammelCheckWMess()" [disabled]="anzSammel == 0">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="wmesscheck" size="'lg'" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'lg'">
              {{ 'Dokumentation übetrprüfen auf falschen Einträge aus der Weichenmessungen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>

        @if (optInterface == 0 || optInterface > 100 || optInterface == 2) {
          <button class="btn" (click)="SammelSAP()" [disabled]="anzSammel == 0">
            <clr-tooltip>
              @if (optInterface == 2) {
                <cds-icon clrTooltipTrigger shape="infralife" size="'lg'" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'INFRALIFE Export' | mrTranslate }}
                </clr-tooltip-content>
              }
              @if (optInterface > 100) {
                <cds-icon clrTooltipTrigger shape="sap" size="'lg'" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'sm'">
                  {{ 'SAP Export' | mrTranslate }}
                </clr-tooltip-content>
              }
              @if (optInterface == 0) {
                <cds-icon clrTooltipTrigger shape="zedas" size="'lg'" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'sm'">
                  {{ 'zedas Export' | mrTranslate }}
                </clr-tooltip-content>
              }
            </clr-tooltip>
          </button>
        }

        <button class="btn" (click)="SammelPDF()" [disabled]="anzSammel == 0">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="pdffile" size="'lg'" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'erstelle PDF Dokumentation' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>

        <button class="btn" (click)="SammelExit()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="logout" size="'lg'" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'sm'">
              {{ 'Beenden' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
      </div>
    </div>
  </clr-modal>
}
@if (showResultText) {
  <clr-modal [(clrModalOpen)]="showResultText" [clrModalSize]="'xl'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Ergebnis' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm>
        <clr-textarea-container>
          <label>{{ 'Inhalt' | mrTranslate }}</label>
          <textarea clrTextarea [(ngModel)]="ResultText" name="description" style="min-height: 650px"></textarea>
        </clr-textarea-container>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn" (click)="showResultText = false">{{ 'Beenden' | mrTranslate }}</button>
    </div>
  </clr-modal>
}
@if (showIFC) {
  <clr-modal [(clrModalOpen)]="showIFC" [clrModalSize]="'xl'">
    <h3 class="modal-title">{{ 'IFC-Datei' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm>
        <div width="600px" height="600px">
          <canvas #canvas id="canvas" width="600px" height="600px"></canvas>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="showIFC = false">
        {{ 'Schließen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>
}
@if (isReplikatProgressOpen()) {
  <app-replikat-progress
    [mode]="isRep ? 'syncback' : 'setup'"
    [setupConfig]="setupConfig()"
    [(modalOpen)]="isReplikatProgressOpen" />
}
@if (isUserReplikatModalOpen()) {
  <app-replikat-setup
    [(setupConfig)]="setupConfig"
    (setupConfigChange)="isReplikatProgressOpen.set(true)"
    [(modalOpen)]="isUserReplikatModalOpen" />
}
